<template>
  <DefaultPage id="about">
    <div class="hero hero-tall">
      <PillsRandom
        hero
        context="for-doctors"
        :columns="40"
      />
      <div class="hero-flex-wrap">
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-middle">
            <div class="cell large-6">
              <div class="hero__call">
                <div class="hero-part">
                  <h1 class="hero__headline__small">
                    Protect, Support<br/><span class="text-light-blue italic-light">and</span> Advocate
                  </h1>
                </div>
              </div>
            </div>
            <div class="cell large-6">
              <div class="hero-part">
                <div class="hero__call__content">
                  <p>In 1975, SVMIC was created by doctors for doctors and continues to be 100% owned and governed by our members. As a mutual company, each one of our members has a say in how we utilize our resources, provide ongoing education, and protect the best interests of the group as a whole. Physician involvement and physician governance mean that we are able to always keep your interests at heart.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content-wrap">
      <div id="our-mission"
          class="our-section"
          data-aos="fade-in"
          data-aos-duration="400">
        <div class="grid-container">
          <div class="grid-x align-center">
            <div class="cell medium-8 large-6 rel">
              <h2>Our Mission</h2>
              <div class="flex-container align-right">
                <h5>Protect, support, and advocate for physicians and other healthcare providers.</h5>
              </div>
              <PillsAccent
                :top="25"
                :left="-40"
              >
                <PillColumn>
                  <Pill
                    color="purple"
                    height="tall"
                  />
                  <Pill
                    color="paleBlue"
                    height="medium"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="mediumBlue"
                    height="xtall"
                    :offset="2"
                  />
                </PillColumn>
              </PillsAccent>
            </div>
          </div>
        </div>
      </div>
      <div id="our-vision"
          class="our-section"
          data-aos="fade-in"
          data-aos-duration="400">
        <div class="grid-container">
          <div class="grid-x align-center">
            <div class="cell medium-8 large-6 rel">
              <h2>Our Vision</h2>
              <div class="flex-container align-right">
                <h5>To be the premier provider of medical professional liability insurance, education, and support in the markets we serve.</h5>
              </div>
              <PillsAccent
                :top="25"
                :left="-40"
              >
                <PillColumn>
                  <Pill
                    color="paleBlue"
                    height="medium"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="purple"
                    height="medium"
                    :offset="2"
                  />
                </PillColumn>
              </PillsAccent>
            </div>
          </div>
        </div>
      </div>
      <div id="our-values"
          class="our-section"
          data-aos="fade-in"
          data-aos-duration="400">
        <div class="grid-container">
          <div class="grid-x align-center">
            <div class="cell medium-8 large-6 rel">
              <h2>Our Values</h2>
              <PillsAccent
                :top="-80"
                :left="-40"
              >
                <PillColumn>
                  <Pill
                    color="purple"
                    height="xxtall"
                    :offset="1"
                  />
                </PillColumn>
                <PillColumn>
                  <Pill
                    color="paleBlue"
                    height="tall"
                  />
                  <Pill
                    color="tangerine"
                    height="medium"
                  />
                </PillColumn>
              </PillsAccent>
              <ValuesMasterDetail/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ValuesMasterDetail from '@/components/master-detail/ValuesMasterDetail';
import Pill from '@/components/pills/Pill';
import PillColumn from '@/components/pills/PillColumn';
import PillsAccent from '@/components/pills/PillsAccent';
import PillsRandom from '@/components/pills/PillsRandom';

export default {
  name: 'About',
  components: {
    ValuesMasterDetail,
    DefaultPage,
    Pill,
    PillColumn,
    PillsAccent,
    PillsRandom
  }
};
</script>
